export const productTypes = {
  uniqueCode: 'Unique Code',
  smsCode: 'SMS Code',
  accountUpdate: 'Account Update',
  automaticRedemption: 'Automatic Redemption',
};

export const getKey = (obj, val) =>
  Object.keys(obj).find((key) => obj[key] === val);
